var _path, _path2, _path3, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1162 12.7752H24.8914C24.0319 12.7752 23.3352 12.0785 23.3352 11.219V4.99417",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32947 12.7752V8.10658C9.32947 6.38764 10.7229 4.99417 12.4419 4.99417H23.603C24.4284 4.99417 25.2199 5.32238 25.8034 5.90611L30.2044 10.3071C30.7881 10.8906 31.1163 11.6821 31.1163 12.5075V29.8934C31.1163 31.6124 29.7228 33.0058 28.0039 33.0058H12.4419C10.7229 33.0058 9.32947 31.6124 9.32947 29.8934V28.3372",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2566 17.9324V20.9733L14.6469 22.4299",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.66077,
    y: 12.7752,
    width: 15.562,
    height: 15.562,
    rx: 3,
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileTime);
export default __webpack_public_path__ + "static/media/file-time.f6e9a05aa86692d1a6f7b0a60f687730.svg";
export { ForwardRef as ReactComponent };